import CompanyThemeLogo from './CompanyThemeLogo'

export default CompanyThemeLogo